<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>Balance Sheet</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary d-flex justify-center align-center">
          <v-col cols="5">
            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td style="text-align: left;">Assets</td>
                    <td style="text-align: right;"></td>
                  </tr>
                  <tr v-for="(asset, index) of balanceSheet.assets" v-bind:key="index">
                    <td style="text-align: left;">
                      <div style="margin-left: 40px;">{{ asset.account }}</div>
                    </td>
                    <td style="text-align: right;">{{ asset.balance | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <!-- assets table -->
            <v-simple-table dense style="margin-top: 50px">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      <span style="color: blue">Total Current Assets</span>
                    </td>
                    <td
                      style="text-align: right; text-decoration: underline;"
                    ><span style="color: blue">{{ balanceSheet.totalAssets | currency }}</span></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- end -->

            <!-- assets table -->
            <v-simple-table dense style="margin-top: 15px">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      Total Assets
                    </td>
                    <td
                      style="text-align: right; text-decoration: underline;"
                    >{{ balanceSheet.totalAssets | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- end -->
          </v-col>

          <v-col cols="5">
            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td style="text-align: left;">Liabilities</td>
                    <td style="text-align: right;"></td>
                  </tr>
                  <tr v-for="(liability, index) of balanceSheet.liabilities" v-bind:key="index">
                    <td style="text-align: left;">
                      <div style="margin-left: 40px;">{{ liability.account }}</div>
                    </td>
                    <td style="text-align: right;">{{ liability.balance | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <!-- total liabilities table -->
            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      <span style="color: blue">Total Liabilities</span>
                    </td>
                    <td
                      style="text-align: right; text-decoration: underline;"
                    ><span style="color: blue">{{ balanceSheet.totalLiabilities | currency }}</span></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- end -->

            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td style="text-align: left;">Equity</td>
                    <td style="text-align: right;"></td>
                  </tr>
                  <tr v-for="(capitalRecord, index) of balanceSheet.capital" v-bind:key="index">
                    <td style="text-align: left;">
                      <div style="margin-left: 40px;">{{ capitalRecord.account }}</div>
                    </td>
                    <td style="text-align: right;">{{ capitalRecord.balance | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <!-- total capital & reserves table -->
            <v-simple-table dense class="mt-2">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      <span style="color: blue">Total Equity</span>
                    </td>
                    <td
                      style="text-align: right; text-decoration: underline;"
                    ><span style="color: blue">{{ balanceSheet.totalCapital | currency }}</span></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- end -->

             <!-- assets table -->
             <v-simple-table dense style="margin-top: 15px">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                    Profit & Loss
                    </td>
                    <td
                      style="text-align: right; text-decoration: underline;"
                    >
                    <span v-if=" balanceSheet.pnl  > 0" style="color: green">{{  balanceSheet.pnl | currency }}</span>
                    <span v-else style="color: red">{{  balanceSheet.pnl | currency }}</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- end -->

            <!-- assets table -->
            <v-simple-table dense style="margin-top: 15px">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                    Total Liabilities & Equity
                    </td>
                    <td
                      style="text-align: right; text-decoration: underline;"
                    >{{ (balanceSheet.totalLiabilities + balanceSheet.totalCapital + balanceSheet.pnl) | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- end -->

            
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>
    
    <script>
export default {
  data: () => ({
    search: "",
    zeroValue: 0,
    headers: [
      { text: "Account Name", value: "Name" },
      // { text: "Account Type", value: "Type" },
      { text: "Category", value: "AccountCategory.Name" },
      { text: "Owner", value: "owner.name" },
      // { text: "Balance", value: "Balance" },
      { text: "Action", value: "action" }
    ],
    balanceSheet: {}
  }),
  methods: {
    getReport() {
      const self = this;
      this.$store
        .dispatch("get", `/balance-sheet`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.balanceSheet = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getReport();
  }
};
</script>